<div>
    <div mat-dialog-title class="title d-flex flex-row justify-content-end pt-2">
        <a (click)="onNoClick()">X</a>
    </div>
    <div mat-dialog-content>
        <div class="d-flex justify-content-center check">
            <svg width="89" height="88" viewBox="0 0 89 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M81.1664 40.6268V44.0002C81.1618 51.907 78.6015 59.6006 73.8672 65.9335C69.133 72.2664 62.4784 76.8993 54.896 79.1411C47.3136 81.383 39.2096 81.1138 31.7927 78.3736C24.3758 75.6335 18.0434 70.5692 13.7399 63.9361C9.43632 57.303 7.39224 49.4564 7.91249 41.5666C8.43274 33.6769 11.4894 26.1667 16.6267 20.1561C21.764 14.1455 28.7066 9.95656 36.419 8.21402C44.1315 6.47149 52.2007 7.26872 59.423 10.4868" stroke="#287F3C" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M81.1667 14.666L44.5 51.3694L33.5 40.3694" stroke="#287F3C" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
        <div class="d-flex flex-column align-items-center">
            <h4 class="sucesso">{{ data.title | translate }}</h4>
            <h6 class="info-sucesso">{{ data.info | translate }}</h6>
        </div>
    </div>
</div>
